// "use client";

// import {
//   Container,
//   Grid,
//   Typography,
//   Card,
//   CardMedia,
//   CardContent,
//   Button,
//   Chip,
//   Box,
//   Skeleton,
//   TextField,
//   InputAdornment,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Pagination,
//   Alert,
//   IconButton,
//   useTheme,
//   // alpha,
// } from "@mui/material";
// import Link from "next/link";
// import { theme } from "@/styles/theme";
// import { Post } from "@/types/post";
// import { formatDate } from "@/lib/utils";
// import { Search, Refresh } from "@mui/icons-material";
// import React, { useCallback, useEffect, useState, useMemo } from "react";

// export const runtime = "edge";

// export const metadata = {
//   title: "LinXar Labs Blog - Web Development Insights & Trends",
//   description:
//     "Stay updated with the latest web development trends, AI integration strategies, and digital transformation insights from LinXar Labs experts.",
//   openGraph: {
//     title: "LinXar Labs Blog - Web Development Insights & Trends",
//     description:
//       "Stay updated with the latest web development trends, AI integration strategies, and digital transformation insights from LinXar Labs experts.",
//     type: "website",
//     url: "https://www.linxarlabs.com/resources/blog",
//   },
//   twitter: {
//     card: "summary_large_image",
//     title: "LinXar Labs Blog - Web Development Insights & Trends",
//     description:
//       "Stay updated with the latest web development trends, AI integration strategies, and digital transformation insights from LinXar Labs experts.",
//   },
//   robots: { index: true, follow: true },
// };

// import { collection, getDocs, query, orderBy, where } from "firebase/firestore";
// import { db } from "@/lib/firebase";

// // Calculate reading time
// const calculateReadingTime = (content: string): string => {
//   const wordsPerMinute = 200;
//   const words = content.split(/\s+/).length;
//   const minutes = Math.ceil(words / wordsPerMinute);
//   return `${minutes} min read`;
// };

// // Memoized Blog Post Card Component
// const BlogPostCard = React.memo(({ post }: { post: Post }) => {
//   const readingTime = calculateReadingTime(post.content);

//   return (
//     <Grid size={{ xs: 12, sm: 6, md: 4 }}>
//       <Card
//         sx={{
//           height: "100%",
//           display: "flex",
//           flexDirection: "column",
//           transition: "transform 0.3s ease, box-shadow 0.3s ease",
//           borderRadius: "12px",
//           overflow: "hidden",
//           boxShadow: 2,
//           "&:hover": {
//             transform: "translateY(-8px)",
//             boxShadow: 4,
//           },
//         }}
//         role="article"
//         aria-labelledby={`post-title-${post.slug}`}
//       >
//         <CardMedia
//           component="img"
//           image={post.featuredImage}
//           alt={post.featuredAlt || post.title}
//           loading="lazy"
//           sx={{
//             height: 240,
//             objectFit: "cover",
//             borderBottom: `4px solid ${theme.palette.secondary.main}`,
//           }}
//         />
//         <CardContent
//           sx={{
//             flexGrow: 1,
//             padding: 3,
//             backgroundColor: theme.palette.background.paper,
//           }}
//         >
//           <Box
//             sx={{
//               mb: 2,
//               display: "flex",
//               flexWrap: "wrap",
//               gap: 1,
//               alignItems: "center",
//             }}
//           >
//             <Chip
//               label={formatDate(post.publishedAt)}
//               size="small"
//               sx={{
//                 backgroundColor: theme.palette.neutral.light,
//                 fontWeight: 500,
//               }}
//             />
//             <Chip
//               label={readingTime}
//               size="small"
//               variant="outlined"
//               sx={{
//                 borderColor: theme.palette.primary.light,
//                 color: theme.palette.primary.main,
//               }}
//             />
//             {post.focus_keywords?.slice(0, 2).map((keyword) => (
//               <Chip
//                 key={keyword}
//                 label={keyword}
//                 size="small"
//                 sx={{
//                   backgroundColor: theme.palette.secondary.light,
//                   color: theme.palette.secondary.contrastText,
//                 }}
//               />
//             ))}
//           </Box>

//           <Typography
//             id={`post-title-${post.slug}`}
//             variant="h3"
//             sx={{
//               fontSize: "1.5rem",
//               fontWeight: 700,
//               lineHeight: 1.3,
//               mb: 2,
//               color: theme.palette.secondary.dark,
//             }}
//           >
//             {post.title}
//           </Typography>

//           <Typography
//             variant="body1"
//             sx={{
//               mb: 3,
//               color: theme.palette.text.secondary,
//               lineHeight: 1.6,
//               fontSize: "1rem",
//               display: "-webkit-box",
//               WebkitLineClamp: 3,
//               WebkitBoxOrient: "vertical",
//               overflow: "hidden",
//             }}
//           >
//             {post.excerpt}
//           </Typography>

//           <Link
//             href={`/resources/blog/${post.slug}`}
//             aria-label={`Read more about ${post.title}`}
//             passHref
//           >
//             <Button
//               variant="contained"
//               sx={{
//                 cursor: "pointer",
//                 backgroundColor: theme.palette.secondary.main,
//                 "&:hover": {
//                   backgroundColor: theme.palette.secondary.dark,
//                 },
//               }}
//             >
//               Read Article
//             </Button>
//           </Link>
//         </CardContent>
//       </Card>
//     </Grid>
//   );
// });

// BlogPostCard.displayName = "BlogPostCard";

// export default function BlogLists() {
//   const theme = useTheme();
//   const [posts, setPosts] = useState<Post[]>([]);
//   const [filteredPosts, setFilteredPosts] = useState<Post[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedTag, setSelectedTag] = useState("");
//   const [page, setPage] = useState(1);
//   const [retryCount, setRetryCount] = useState(0);
//   const postsPerPage = 9;

//   // Get all unique tags - FIXED: Removed console.log and fixed variable naming
//   const allTags = useMemo(() => {
//     const keywords = posts.flatMap((post) => {
//       return post.focus_keywords || [];
//     });
//     return Array.from(new Set(keywords)).sort();
//   }, [posts]);

//   // Filter posts based on search and tag
//   useEffect(() => {
//     let filtered = posts;

//     if (searchTerm) {
//       filtered = filtered.filter(
//         (post) =>
//           post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           post.excerpt.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           (post.focus_keywords &&
//             post.focus_keywords.some((keyword) =>
//               keyword.toLowerCase().includes(searchTerm.toLowerCase())
//             ))
//       );
//     }

//     if (selectedTag) {
//       filtered = filtered.filter(
//         (post) =>
//           post.focus_keywords && post.focus_keywords.includes(selectedTag)
//       );
//     }

//     setFilteredPosts(filtered);
//     setPage(1); // Reset to first page when filters change
//   }, [posts, searchTerm, selectedTag]);

//   // Pagination
//   const paginatedPosts = useMemo(() => {
//     const startIndex = (page - 1) * postsPerPage;
//     return filteredPosts.slice(startIndex, startIndex + postsPerPage);
//   }, [filteredPosts, page]);

//   const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

//   const fetchPosts = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       const q = query(
//         collection(db, "posts"),
//         where("status", "==", "PUBLISHED"),
//         orderBy("publishedAt", "desc")
//       );

//       const querySnapshot = await getDocs(q);
//       const postsData = querySnapshot.docs.map((doc) => {
//         return {
//           id: doc.id,
//           slug: doc.data().slug || doc.id,
//           title: doc.data().title || "Untitled Post",
//           content: doc.data().content || "",
//           status: doc.data().status || "draft",
//           featuredImage: doc.data().featuredImage || "",
//           featuredAlt: doc.data().featuredAlt || "",
//           publishedAt: doc.data().publishedAt || new Date().toISOString(),
//           focus_keywords: doc.data().focus_keywords || [],
//           // excerpt: generateExcerpt(doc.data().content || ""),
//           metaDescription: doc.data().metaDescription || "",
//           excerpt: doc.data().excerpt || "",
//         };
//       }) as Post[];

//       setPosts(postsData);
//     } catch (error) {
//       console.error("Fetch error:", error);
//       setError("Failed to load blog posts. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchPosts();
//   }, [fetchPosts, retryCount]);

//   // Empty state
//   if (!loading && posts.length === 0) {
//     return (
//       <Container maxWidth="lg" sx={{ pb: 6, pt: 20, textAlign: "center" }}>
//         <Typography variant="h4" color="text.secondary" sx={{ mb: 2 }}>
//           No blog posts yet
//         </Typography>
//         <Typography variant="body1" color="text.secondary">
//           Check back soon for new insights and updates.
//         </Typography>
//       </Container>
//     );
//   }

//   return (
//     <>
//       {/* Skip to content link for accessibility */}
//       <Link
//         href="#main-content"
//         style={{
//           position: "absolute",
//           left: "-10000px",
//           top: "auto",
//           width: "1px",
//           height: "1px",
//           overflow: "hidden",
//         }}
//       >
//         Skip to main content
//       </Link>

//       <Container maxWidth="lg" sx={{ pb: 6, pt: 5 }} id="main-content">
//         <Typography
//           variant="h1"
//           sx={{
//             mb: 6,
//             fontSize: { xs: "2.5rem", md: "3rem" },
//             fontWeight: 800,
//             color: theme.palette.primary.main,
//             textAlign: "center",
//             letterSpacing: "-0.02em",
//             position: "relative",
//             "&:after": {
//               content: '""',
//               position: "absolute",
//               bottom: -8,
//               left: "50%",
//               transform: "translateX(-50%)",
//               width: "120px",
//               height: "4px",
//               backgroundColor: theme.palette.secondary.main,
//               borderRadius: "2px",
//             },
//           }}
//         >
//           Latest Insights
//         </Typography>

//         {/* Search and Filter Section */}
//         <Box
//           sx={{
//             mb: 6,
//             display: "flex",
//             flexDirection: { xs: "column", sm: "row" },
//             gap: 2,
//             alignItems: "center",
//           }}
//         >
//           <TextField
//             placeholder="Search articles..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             sx={{
//               flexGrow: 1,
//               maxWidth: { sm: "400px" },
//               "& .MuiOutlinedInput-root": {
//                 borderRadius: 2,
//               },
//             }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Search color="action" />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <FormControl sx={{ minWidth: 150 }}>
//             <InputLabel>Filter by Tag</InputLabel>
//             <Select
//               value={selectedTag}
//               label="Filter by Tag"
//               onChange={(e) => setSelectedTag(e.target.value)}
//               sx={{ borderRadius: 2 }}
//             >
//               <MenuItem value="">All Tags</MenuItem>
//               {allTags.map((keyword) => (
//                 <MenuItem key={keyword} value={keyword}>
//                   {keyword}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {(searchTerm || selectedTag) && (
//             <Button
//               variant="outlined"
//               onClick={() => {
//                 setSearchTerm("");
//                 setSelectedTag("");
//               }}
//             >
//               Clear Filters
//             </Button>
//           )}
//         </Box>

//         {/* Error State */}
//         {error && (
//           <Alert
//             severity="error"
//             sx={{ mb: 4 }}
//             action={
//               <IconButton
//                 aria-label="retry"
//                 color="inherit"
//                 size="small"
//                 onClick={() => {
//                   setRetryCount((prev) => prev + 1);
//                 }}
//               >
//                 <Refresh fontSize="inherit" />
//               </IconButton>
//             }
//           >
//             {error}
//           </Alert>
//         )}

//         {/* Results Count */}
//         {(searchTerm || selectedTag) && (
//           <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//             Found {filteredPosts.length} article
//             {filteredPosts.length !== 1 ? "s" : ""}
//             {searchTerm && ` for "${searchTerm}"`}
//             {selectedTag && ` in "${selectedTag}"`}
//           </Typography>
//         )}

//         {/* Blog Posts Grid */}
//         <Grid container spacing={4}>
//           {loading
//             ? [1, 2, 3, 4, 5, 6].map((i) => (
//                 <Grid size={{ xs: 12, sm: 6, md: 4 }} key={i}>
//                   <Card sx={{ height: "100%" }}>
//                     <CardContent>
//                       <Skeleton
//                         variant="rectangular"
//                         width="100%"
//                         height={240}
//                       />
//                       <Box sx={{ mt: 2 }}>
//                         <Skeleton variant="text" width="60%" height={32} />
//                         <Skeleton variant="text" width="40%" height={24} />
//                       </Box>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               ))
//             : paginatedPosts.map((post) => (
//                 <BlogPostCard key={post.slug} post={post} />
//               ))}
//         </Grid>

//         {/* No Results State */}
//         {!loading && filteredPosts.length === 0 && posts.length > 0 && (
//           <Box textAlign="center" sx={{ py: 8 }}>
//             <Typography variant="h5" color="text.secondary" sx={{ mb: 2 }}>
//               No articles found
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               Try adjusting your search or filter criteria.
//             </Typography>
//           </Box>
//         )}

//         {/* Pagination */}
//         {totalPages > 1 && (
//           <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
//             <Pagination
//               count={totalPages}
//               page={page}
//               onChange={(_, value) => setPage(value)}
//               color="primary"
//               size="large"
//               sx={{
//                 "& .MuiPaginationItem-root": {
//                   borderRadius: 2,
//                   fontWeight: 600,
//                 },
//               }}
//             />
//           </Box>
//         )}
//       </Container>
//     </>
//   );
// }

// components/blog/BlogListClient.tsx
"use client";

import {
  Container,
  Grid,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Button,
  Chip,
  Box,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
  useTheme,
} from "@mui/material";
import Link from "next/link";
import { Post } from "@/types/post";
import { formatDate } from "@/lib/utils";
import { Search } from "@mui/icons-material";
import React, { useEffect, useState, useMemo } from "react";

// Calculate reading time
const calculateReadingTime = (content: string): string => {
  const wordsPerMinute = 200;
  const words = content.split(/\s+/).length;
  const minutes = Math.ceil(words / wordsPerMinute);
  return `${minutes} min read`;
};

// Memoized Blog Post Card Component
const BlogPostCard = React.memo(({ post }: { post: Post }) => {
  const readingTime = calculateReadingTime(post.content);
  const theme = useTheme();

  return (
    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
      <Card
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: 2,
          "&:hover": {
            transform: "translateY(-8px)",
            boxShadow: 4,
          },
        }}
        role="article"
        aria-labelledby={`post-title-${post.slug}`}
      >
        <CardMedia
          component="img"
          image={post.featuredImage}
          alt={post.featuredAlt || post.title}
          loading="lazy"
          sx={{
            height: 240,
            objectFit: "cover",
            borderBottom: `4px solid ${theme.palette.secondary.main}`,
          }}
        />
        <CardContent
          sx={{
            flexGrow: 1,
            padding: 3,
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <Box
            sx={{
              mb: 2,
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              alignItems: "center",
            }}
          >
            <Chip
              label={formatDate(post.publishedAt)}
              size="small"
              sx={{
                backgroundColor: theme.palette.neutral.light,
                fontWeight: 500,
              }}
            />
            <Chip
              label={readingTime}
              size="small"
              variant="outlined"
              sx={{
                borderColor: theme.palette.primary.light,
                color: theme.palette.primary.main,
              }}
            />
            {post.focus_keywords?.slice(0, 2).map((keyword) => (
              <Chip
                key={keyword}
                label={keyword}
                size="small"
                sx={{
                  backgroundColor: theme.palette.secondary.light,
                  color: theme.palette.secondary.contrastText,
                }}
              />
            ))}
          </Box>

          <Typography
            id={`post-title-${post.slug}`}
            variant="h3"
            sx={{
              fontSize: "1.5rem",
              fontWeight: 700,
              lineHeight: 1.3,
              mb: 2,
              color: theme.palette.secondary.dark,
            }}
          >
            {post.title}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 3,
              color: theme.palette.text.secondary,
              lineHeight: 1.6,
              fontSize: "1rem",
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {post.excerpt}
          </Typography>

          <Link
            href={`/resources/blog/${post.slug}`}
            aria-label={`Read more about ${post.title}`}
            passHref
          >
            <Button
              variant="contained"
              sx={{
                cursor: "pointer",
                backgroundColor: theme.palette.secondary.main,
                "&:hover": {
                  backgroundColor: theme.palette.secondary.dark,
                },
              }}
            >
              Read Article
            </Button>
          </Link>
        </CardContent>
      </Card>
    </Grid>
  );
});

BlogPostCard.displayName = "BlogPostCard";

interface BlogListClientProps {
  initialPosts: Post[];
}

export default function BlogListClient({ initialPosts }: BlogListClientProps) {
  const theme = useTheme();
  const [posts] = useState<Post[]>(initialPosts);
  const [filteredPosts, setFilteredPosts] = useState<Post[]>(initialPosts);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTag, setSelectedTag] = useState("");
  const [page, setPage] = useState(1);
  const postsPerPage = 9;

  // Get all unique tags
  const allTags = useMemo(() => {
    const keywords = posts.flatMap((post) => post.focus_keywords || []);
    return Array.from(new Set(keywords)).sort();
  }, [posts]);

  // Filter posts based on search and tag
  useEffect(() => {
    let filtered = posts;

    if (searchTerm) {
      filtered = filtered.filter(
        (post) =>
          post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          post.excerpt.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (post.focus_keywords &&
            post.focus_keywords.some((keyword) =>
              keyword.toLowerCase().includes(searchTerm.toLowerCase())
            ))
      );
    }

    if (selectedTag) {
      filtered = filtered.filter(
        (post) =>
          post.focus_keywords && post.focus_keywords.includes(selectedTag)
      );
    }

    setFilteredPosts(filtered);
    setPage(1);
  }, [posts, searchTerm, selectedTag]);

  // Pagination
  const paginatedPosts = useMemo(() => {
    const startIndex = (page - 1) * postsPerPage;
    return filteredPosts.slice(startIndex, startIndex + postsPerPage);
  }, [filteredPosts, page]);

  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

  return (
    <>
      <Link
        href="#main-content"
        style={{
          position: "absolute",
          left: "-10000px",
          top: "auto",
          width: "1px",
          height: "1px",
          overflow: "hidden",
        }}
      >
        Skip to main content
      </Link>

      <Container maxWidth="lg" sx={{ pb: 6, pt: 5 }} id="main-content">
        <Typography
          variant="h1"
          sx={{
            mb: 6,
            fontSize: { xs: "2.5rem", md: "3rem" },
            fontWeight: 800,
            color: theme.palette.primary.main,
            textAlign: "center",
            letterSpacing: "-0.02em",
            position: "relative",
            "&:after": {
              content: '""',
              position: "absolute",
              bottom: -8,
              left: "50%",
              transform: "translateX(-50%)",
              width: "120px",
              height: "4px",
              backgroundColor: theme.palette.secondary.main,
              borderRadius: "2px",
            },
          }}
        >
          Latest Insights
        </Typography>

        {/* Search and Filter Section */}
        <Box
          sx={{
            mb: 6,
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
            alignItems: "center",
          }}
        >
          <TextField
            placeholder="Search articles..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              flexGrow: 1,
              maxWidth: { sm: "400px" },
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search color="action" />
                </InputAdornment>
              ),
            }}
          />

          <FormControl sx={{ minWidth: 150 }}>
            <InputLabel>Filter by Tag</InputLabel>
            <Select
              value={selectedTag}
              label="Filter by Tag"
              onChange={(e) => setSelectedTag(e.target.value)}
              sx={{ borderRadius: 2 }}
            >
              <MenuItem value="">All Tags</MenuItem>
              {allTags.map((keyword) => (
                <MenuItem key={keyword} value={keyword}>
                  {keyword}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {(searchTerm || selectedTag) && (
            <Button
              variant="outlined"
              onClick={() => {
                setSearchTerm("");
                setSelectedTag("");
              }}
            >
              Clear Filters
            </Button>
          )}
        </Box>

        {/* Results Count */}
        {(searchTerm || selectedTag) && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Found {filteredPosts.length} article
            {filteredPosts.length !== 1 ? "s" : ""}
            {searchTerm && ` for "${searchTerm}"`}
            {selectedTag && ` in "${selectedTag}"`}
          </Typography>
        )}

        {/* Blog Posts Grid */}
        <Grid container spacing={4}>
          {paginatedPosts.map((post) => (
            <BlogPostCard key={post.slug} post={post} />
          ))}
        </Grid>

        {/* No Results State */}
        {filteredPosts.length === 0 && posts.length > 0 && (
          <Box textAlign="center" sx={{ py: 8 }}>
            <Typography variant="h5" color="text.secondary" sx={{ mb: 2 }}>
              No articles found
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Try adjusting your search or filter criteria.
            </Typography>
          </Box>
        )}

        {/* Empty state */}
        {posts.length === 0 && (
          <Box textAlign="center" sx={{ py: 8 }}>
            <Typography variant="h4" color="text.secondary" sx={{ mb: 2 }}>
              No blog posts yet
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Check back soon for new insights and updates.
            </Typography>
          </Box>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={(_, value) => setPage(value)}
              color="primary"
              size="large"
              sx={{
                "& .MuiPaginationItem-root": {
                  borderRadius: 2,
                  fontWeight: 600,
                },
              }}
            />
          </Box>
        )}
      </Container>
    </>
  );
}
